/* GOUP — escolha consciente do tamanho na página de produto.
   O tema pré-seleciona a primeira variante (ex.: tamanho P). Este script não altera a variante nem o carrinho:
   enquanto a cliente não tocar num tamanho, o tamanho aparece como não escolhido, os botões de compra
   (principal e barra fixa) mostram "Escolha o tamanho" e o clique leva-a até ao seletor.
   Não atua quando o link já traz ?variant= (escolha explícita) nem em produtos com um só tamanho.
   Para desfazer: remova a linha que carrega este arquivo no layout/theme.liquid. */
(function () {
  'use strict';
  try {
    if (/[?&]variant=/.test(window.location.search)) return;
    if (window.Shopify && window.Shopify.designMode) return;

    var root = document.documentElement;
    var SCOPE = '.product-information .column-right';
    var STICKY = '#md-sticky-atc';
    var pending = false;

    function sizeFieldset() {
      var scope = document.querySelector(SCOPE);
      if (!scope) return null;
      var sets = scope.querySelectorAll('fieldset.variant-option');
      for (var i = 0; i < sets.length; i++) {
        var legend = sets[i].querySelector('legend');
        if (legend && /^\s*tamanho/i.test(legend.textContent || '')) return sets[i];
      }
      return null;
    }

    function mark() {
      var fs = sizeFieldset();
      if (fs && !fs.classList.contains('goup-size-fs')) fs.classList.add('goup-size-fs');
      return fs;
    }

    function clearPending() {
      if (!pending) return;
      pending = false;
      root.classList.remove('goup-size-pending');
      var msg = document.querySelector('.goup-size-msg');
      if (msg) msg.remove();
    }

    function showMessage(fs) {
      if (!fs || fs.querySelector('.goup-size-msg')) return;
      var p = document.createElement('p');
      p.className = 'goup-size-msg';
      p.setAttribute('role', 'alert');
      p.textContent = 'Escolha o tamanho para continuar.';
      var legend = fs.querySelector('legend');
      if (legend && legend.nextSibling) fs.insertBefore(p, legend.nextSibling);
      else fs.appendChild(p);
    }

    function isGuardedButton(el) {
      var btn = el && el.closest ? el.closest('button[type="submit"], input[type="submit"]') : null;
      if (!btn || !btn.form) return false;
      var action = btn.form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return false;
      return !!(btn.closest(SCOPE) || btn.closest(STICKY));
    }

    function block(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var fs = mark();
      showMessage(fs);
      if (fs) {
        fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var first = fs.querySelector('input[type="radio"]');
        if (first) {
          try { first.focus({ preventScroll: true }); } catch (err) { first.focus(); }
        }
      }
    }

    function init() {
      var fs = mark();
      if (!fs || fs.querySelectorAll('input[type="radio"]').length < 2) return;

      var style = document.createElement('style');
      style.textContent =
        '.goup-size-pending .goup-size-fs .variant-option__button-label:has(input:checked){' +
          'border-color:rgb(244,244,242)!important;border-width:.8px!important;outline:none!important}' +
        '.goup-size-pending .goup-size-fs legend .variant-option__swatch-value{display:none}' +
        '.goup-size-pending .goup-size-fs legend::after{content:"escolha";font-weight:400;color:#6B6B6B}' +
        '.goup-size-msg{margin:6px 0 0;font-size:.875rem;font-weight:600;color:#0A0A0A}' +
        '.goup-size-pending ' + SCOPE + ' .add-to-cart-text__content{display:none}' +
        '.goup-size-pending ' + SCOPE + ' .add-to-cart-text::after{content:"ESCOLHA O TAMANHO"}' +
        '.goup-size-pending ' + STICKY + ' .atc-btn{font-size:0!important}' +
        '.goup-size-pending ' + STICKY + ' .atc-btn::after{content:"Escolha o tamanho";font-size:16px}';
      document.head.appendChild(style);

      pending = true;
      root.classList.add('goup-size-pending');

      // A cliente escolhe um tamanho no seletor principal (ou uma combinação no seletor da barra fixa).
      document.addEventListener('change', function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        var fsNow = t.closest('fieldset.variant-option');
        if (fsNow && fsNow.closest(SCOPE)) {
          var legend = fsNow.querySelector('legend');
          if (legend && /^\s*tamanho/i.test(legend.textContent || '')) clearPending();
        }
        if (t.matches && t.matches(STICKY + ' select[name="id"]') && e.isTrusted) clearPending();
      }, true);

      // Clique num tamanho que já estava marcado (P) também conta como escolha.
      document.addEventListener('click', function (e) {
        var label = e.target && e.target.closest ? e.target.closest('.goup-size-fs .variant-option__button-label') : null;
        if (label) clearPending();
      }, true);

      // Bloqueia o envio enquanto o tamanho não foi escolhido (fase de captura, antes de qualquer outro script).
      window.addEventListener('click', function (e) {
        if (pending && isGuardedButton(e.target)) block(e);
      }, true);
      window.addEventListener('submit', function (e) {
        if (!pending) return;
        var f = e.target;
        if (f && f.closest && (f.closest(SCOPE) || f.closest(STICKY)) && (f.getAttribute('action') || '').indexOf('/cart/add') !== -1) block(e);
      }, true);

      // O tema pode recriar a secção inteira ao trocar de cor: observa o MainContent e volta a marcar o fieldset.
      var scopeEl = document.getElementById('MainContent') || document.body;
      if (scopeEl && 'MutationObserver' in window) {
        var t;
        new MutationObserver(function () {
          clearTimeout(t);
          t = setTimeout(mark, 50);
        }).observe(scopeEl, { childList: true, subtree: true });
      }
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  } catch (err) {
    document.documentElement.classList.remove('goup-size-pending');
  }
})();
